import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ExceptionTags } from 'src/app/features/restaurants/models/List.Cancellation';
import { RefundPolicyService } from 'src/app/features/restaurants/services/Cancellation.service';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import Swal from 'sweetalert2';


export interface DialogData {
  exceptionTags: any[]
  restaurantId: number
}

@Component({
  selector: 'app-exception-rule-guests-tags',
  templateUrl: './exception-rule-guests-tags.component.html'
})
export class ExceptionRuleGuestsTagsComponent extends DirtyComponent implements OnInit {
  loading = false;
  isSubmitted = false;

  isUpdate: boolean = this.data ? true : false;
  allTags: any[] = []
  tagsCopy: any = [];
  selectedTags: any[] = [];
  constructor(override dialogRef: MatDialogRef<ExceptionRuleGuestsTagsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private formBuilder: FormBuilder,
    translate: TranslateService, private service: RefundPolicyService) {
    super(translate)
  }

  ngOnInit(): void {
    this.GetExceptionTags();

  }
  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }
  override canDeactivate(): boolean {
    return this.selectedTags.length !== this.tagsCopy.length
  };

  GetExceptionTags() {
    this.loading = true;
    this.service.GetExceptionTags(this.data.restaurantId).subscribe((data: any) => {
      this.loading = false;
      this.allTags = data.allTags
      this.selectedTags = data.selectedTags || []
      this.tagsCopy = JSON.parse(JSON.stringify(this.selectedTags))

      this.allTags.forEach(element => {
        if (element.isSelected) {
          this.pushSelectedTag(element)
        }
      });
    },
      (error: any) => {
        this.loading = false;
      })
  }

  pushSelectedTag(tag?: ExceptionTags) {
    if (!this.selectedTags.includes(tag?.id)) {
      this.selectedTags.push(tag?.id)
    }
  }

  onChangeEventFunc(tag: ExceptionTags, isChecked?: any) {
    if (isChecked && !this.selectedTags.includes(tag?.id)) {
      this.selectedTags.push(tag?.id);


    } else {
      let i = this.selectedTags.indexOf(tag?.id);
      if (i !== -1) {
        this.selectedTags.splice(i, 1);
      }
    }
  }

  saveRecord(openNew: boolean = false) {
    this.isSubmitted = true;
    if (this.selectedTags.length > 0) {
      this.loading = true;
      let data = {
        exceptionTags: this.selectedTags,
        restaurantId: this.data.restaurantId
      };

      let msg = this.translate.instant('swalMsg.savedsuccessfully');
      if (this.isUpdate) {
        data.exceptionTags = this.selectedTags;
        data.restaurantId = this.data.restaurantId
        msg = this.translate.instant('swalMsg.updatedsuccessfully');
      }
      this.service.EditExceptionTags(data).subscribe(() => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: msg,
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        if (openNew) {
          this.formGroup.reset();
          this.service.refreshList.next(true);
        } else {
          this.dialogRef.close(true);
        }
      }, error => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: error.detail,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      });
    } else {
      Swal.fire({
        title: this.translate.instant('swalMsg.Failed'),
        text: this.translate.instant('swalMsg.youShouldChooseAtLeastOneSelection'),
        icon: 'error',
        confirmButtonText: this.translate.instant('swalMsg.Ok'),
      });
    }
  }

}
